import { usePagination } from '@hooks';
import { PaginationMetadata } from '@modules/usersManagment/data/useGetAllUsersPaginated';
import { NamelessCardBulk } from '../constants';

interface pages extends PaginationMetadata {
  page: NamelessCardBulk[];
}
/**
 * A reusable SWR hook for paginated nameless cards bulks.
 * @param {number} customerId - Options for pagination or search.
 * @param {object} paramsState - url params state.
 * @param {function} paramsState.params - Current pagination and search params (URL params).
 * @param {function} paramsState.setParams - Function to set pagination and search params.
 * @returns {PaginationHookResult} - An object containing the data and pagination properties and functions
 */
const useSearchNamelessCardsBulk = ({
  params,
  setURLparams,
  customerId,
}: {
  params: object;
  setURLparams: () => void;
  customerId: number;
}) => {
  const key = customerId ? `/v4/nameless-cards/search/${customerId}` : false;
  const { data: paginatedData, ...props } = usePagination(key, {
    shouldFetchWithoutParams: true,
    params,
    setURLparams,
    paramKeys: ['page', 'limit'],
  });

  const data = paginatedData as pages | undefined;
  return { data, ...props };
};

export default useSearchNamelessCardsBulk;
